<app-launch-field-container 
[basespaceFormControl]="formControl"
labelPaddingLeft="0px"
>
    <div class="checkbox-container">
        <rad-checkbox 
        *ngFor="let choice of formControl.choices; index as i"
        class="rad-theme--light"
        (focus)="onFocus()"
        (change)="updatedSelectedChoices(i, $event.target.checked)"
        [attr.value]="choice.value" 
        [attr.checked]="choice.checked"
        [attr.disabled]="formControl.disabled"
        [appShadowDom]="{ action: 'removeClass', selector: '.rad-checkbox', className: 'rad-checkbox--standalone' }"
        >{{choice.label}}</rad-checkbox>
    </div>
    
</app-launch-field-container>